var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.5,
    height: 90,
    viewBox: "0 0 92.5 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n        stroke-width: 2.5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #00b0a9;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498",
    transform: "translate(-185.75 -298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10495",
    "data-name": "Group 10495",
    transform: "translate(-15 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10491",
    "data-name": "Group 10491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    transform: "translate(270.212 317.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-1",
    d: "M-21048.227-23989.238v-7.525",
    transform: "translate(21059.027 23996.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    className: "cls-1",
    d: "M-21048.227-23989.238v-7.525",
    transform: "translate(21048.227 23996.764)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494",
    "data-name": "Group 10494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7385",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M34.045,31.5H10a10,10,0,0,1-10-10V10",
    transform: "translate(202 307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-2",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M90,31.5V20A10,10,0,0,0,80,10H10A10,10,0,0,0,0,20V31.5",
    transform: "translate(202 297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-3",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M90,10V21.5a10,10,0,0,1-10,10H56.393",
    transform: "translate(202 307)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090",
    "data-name": "Rectangle 3090",
    className: "cls-2",
    width: 14.6,
    height: 7.527,
    rx: 3.763,
    transform: "translate(212.8 317.8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10493",
    "data-name": "Group 10493",
    transform: "translate(240 331.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-3",
    d: "M115.029,42.058a7.029,7.029,0,1,1,7.029-7.029A7.05,7.05,0,0,1,115.029,42.058Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3091",
    "data-name": "Rectangle 3091",
    className: "cls-2",
    width: 14.6,
    height: 7.527,
    rx: 3.763,
    transform: "translate(235.8 317.801)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10492",
    "data-name": "Group 10492",
    transform: "translate(0 47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10467-2",
    "data-name": "Group 10467",
    transform: "translate(270.212 317.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7136-2",
    "data-name": "Path 7136",
    className: "cls-1",
    d: "M-21048.227-23989.238v-7.525",
    transform: "translate(21059.027 23996.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383-2",
    "data-name": "Path 7383",
    className: "cls-1",
    d: "M-21048.227-23989.238v-7.525",
    transform: "translate(21048.227 23996.764)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494-2",
    "data-name": "Group 10494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-4",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M34.045,31.5H10a10,10,0,0,1-10-10V10",
    transform: "translate(202 307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-5",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M90,31.5V20A10,10,0,0,0,80,10H10A10,10,0,0,0,0,20V31.5",
    transform: "translate(202 297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385-6",
    "data-name": "Path 7385",
    className: "cls-2",
    d: "M90,10V21.5a10,10,0,0,1-10,10H56.393",
    transform: "translate(202 307)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090-2",
    "data-name": "Rectangle 3090",
    className: "cls-2",
    width: 14.6,
    height: 7.527,
    rx: 3.763,
    transform: "translate(212.8 317.8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10493-2",
    "data-name": "Group 10493",
    transform: "translate(240 331.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003-2",
    "data-name": "Path 7003",
    className: "cls-3",
    d: "M115.029,42.058a7.029,7.029,0,1,1,7.029-7.029A7.05,7.05,0,0,1,115.029,42.058Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3091-2",
    "data-name": "Rectangle 3091",
    className: "cls-2",
    width: 14.6,
    height: 7.527,
    rx: 3.763,
    transform: "translate(235.8 317.801)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3092",
    "data-name": "Rectangle 3092",
    className: "cls-4",
    width: 90,
    height: 90,
    transform: "translate(187 298)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObHover);
export default __webpack_public_path__ + "static/media/ob-hover.0dcedf08bec59e00fde3aecb7d0f8ab0.svg";
export { ForwardRef as ReactComponent };